import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import LegalDisclaimers from 'components/legal-disclaimers';
import { TextWithArrowButton } from 'components/text-with-arrow-button';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import { AllergensDisclaimer } from './allergens-disclaimer';
import { NutritionModal } from './nutrition-modal';
import {
  NutritionInformationContainer,
  NutritionInformationTitle,
  NutritionInformationWrapper,
} from './styled';

interface IProductNutritionInformationProps {
  selectedProduct: ILocalizedMenuEntry;
}

export const ProductNutritionInformation: React.FC<IProductNutritionInformationProps> = ({
  selectedProduct,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();

  const enableAllergensDisclaimer = useFlag(LaunchDarklyFlag.ENABLE_ALLERGENS_DISCLAIMER);

  if (!selectedProduct.nutrition) {
    return null;
  }

  return (
    <>
      <NutritionInformationWrapper focusable>
        <NutritionInformationContainer>
          <TextWithArrowButton
            messageId="nutritionalInformationAndAllergen"
            onPress={() => setIsModalOpen(true)}
          />
        </NutritionInformationContainer>

        <NutritionInformationTitle>
          {formatMessage({ id: 'information' })}
        </NutritionInformationTitle>

        {enableAllergensDisclaimer && selectedProduct.nutrition.allergens && (
          <AllergensDisclaimer allergens={selectedProduct.nutrition.allergens} />
        )}

        <LegalDisclaimers />
      </NutritionInformationWrapper>

      {isModalOpen && <NutritionModal onDismiss={() => setIsModalOpen(false)} />}
    </>
  );
};
